import SFetch from '@app/utils/sfetch'
import type { CopyCheckListResponse } from './types'

export const copyCheckList = (
  id: number,
  name: string
): Promise<CopyCheckListResponse | null> => {
  return SFetch.json(
    window.Silverfin.Routes.copy_check_list_path(
      window.Silverfin.currentFirmId,
      id
    ),
    {
      method: 'POST',
      body: {
        check_list: {
          name,
        },
      },
    }
  )
}
